import { observer } from 'mobx-react';
import { Maybe } from 'maybeasy';
import { Stripe } from '@stripe/stripe-js';
import { emptyFragment } from '@execonline-inc/execonline-ui';
import { PaymentIntentResource } from '../../../../../DiscoveryPortal/Enrollment/Store/Types';
import { StripeClient, StripeContext, loadOptions } from '../../../../Stripe';
import { PaymentCheckoutFormStore, onPaymentCheckoutFormSubmit } from '../../Common';
import { CheckoutKind, elementsOptionsFor, formPaddingClassName } from './CheckoutKind';
import PaymentCardForm from './PaymentCardForm';
import PaymentErrorNotification from './PaymentErrorNotification';

interface Props {
  stripe: Stripe;
  price: Maybe<number>;
  store: PaymentCheckoutFormStore;
  paymentIntentResource: Maybe<PaymentIntentResource>;
  checkout: CheckoutKind;
}

function PaymentCheckoutForm({ price, stripe, store, paymentIntentResource, checkout }: Props) {
  return (
    <div className={`flex basis-3/5 flex-col gap-y-3 ${formPaddingClassName(checkout)}`}>
      <PaymentErrorNotification store={store} />
      <StripeClient
        stripe={stripe}
        options={loadOptions(paymentIntentResource).map(elementsOptionsFor(checkout))}
      >
        <StripeContext.Consumer>
          {(elements) =>
            elements
              .map((elements) => (
                <PaymentCardForm
                  store={store}
                  price={price}
                  stripe={stripe}
                  onSubmit={onPaymentCheckoutFormSubmit(store, stripe, elements)}
                  checkout={checkout}
                />
              ))
              .getOrElse(emptyFragment)
          }
        </StripeContext.Consumer>
      </StripeClient>
    </div>
  );
}

export default observer(PaymentCheckoutForm);
